import React from 'react';
import { Box, Fade } from '@mui/material';

interface AnimatedPageProps {
  children: React.ReactNode;
}

const AnimatedPage: React.FC<AnimatedPageProps> = ({ children }) => {
  return (
    <Fade in timeout={800}>
      <Box
        sx={{
          p: 3,
          opacity: 0,
          animation: 'fadeIn 0.6s ease-out forwards',
          '@keyframes fadeIn': {
            '0%': {
              opacity: 0,
              transform: 'translateY(20px)',
            },
            '100%': {
              opacity: 1,
              transform: 'translateY(0)',
            },
          },
          '& .MuiPaper-root': {
            opacity: 0,
            animation: 'slideUp 0.6s ease-out 0.2s forwards',
          },
          '& .MuiTypography-root': {
            opacity: 0,
            animation: 'slideDown 0.6s ease-out 0.3s forwards',
          },
          '& .MuiTableContainer-root': {
            opacity: 0,
            animation: 'slideUp 0.6s ease-out 0.4s forwards',
          },
          '& .MuiButton-root': {
            opacity: 0,
            animation: 'fadeIn 0.6s ease-out 0.5s forwards',
          },
          '@keyframes slideUp': {
            '0%': {
              opacity: 0,
              transform: 'translateY(20px)',
            },
            '100%': {
              opacity: 1,
              transform: 'translateY(0)',
            },
          },
          '@keyframes slideDown': {
            '0%': {
              opacity: 0,
              transform: 'translateY(-20px)',
            },
            '100%': {
              opacity: 1,
              transform: 'translateY(0)',
            },
          },
        }}
      >
        {children}
      </Box>
    </Fade>
  );
};

export default AnimatedPage; 